import { storage } from 'BASE/common/util/util.storage';
import { Logout as _Logout } from '#BASE/common/login/login.util';
import { XY_STORAGE_KEYS } from 'XY/common/util/storage.keys';
export * from '#BASE/common/login/login.util';

export const Logout = function () {
    _Logout();
    storage.local.remove(storage.keys.LOGIN_ANNOUCEMENTS);
    storage.local.remove(storage.keys.READ_ANNOUNCEMENT);
    storage.local.remove(storage.keys.LOGIN_MARQUEE);
    storage.local.remove(XY_STORAGE_KEYS.HOME_STATISTICS); //首頁統計資訊，登出就清掉
    storage.local.remove(XY_STORAGE_KEYS.LUCKY7SLOT_MODAL_SEEN_HOME);
    storage.local.remove(XY_STORAGE_KEYS.LUCKY7SLOT_MODAL_SEEN_ACTIVITY);
};
